import { Navigate, Route, Routes } from 'react-router-dom'
import EldIntegrationRequests from './EldIntegrationRequests'

export default function EldIntegrationRequestsRoutes() {
    return (
        <Routes>
            <Route index element={<EldIntegrationRequests />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    )
}
